import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import RouterLink from '../../util/RouterLink';
import { connect } from 'react-redux';
import { Box, Button, Divider, Link, TextField, InputAdornment } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import * as authenticateActions from '../../actions/authenticateActions';
import { notify } from '../../util/notifications';
import { landingRoute } from '../../util/landingRoute';
import AuthLayout from './AuthLayout';
import MfaLogin from './MfaLogin';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

class Login extends Component {
    state = { userName: '', password: '', useMfa: false, submitted: false, signingIn: false };

    onChange = (event) => this.setState({ [event.target.name]: event.target.value });

    errors = () => {
        const { userName, password } = this.state;
        const errors = {};
        if (!userName.trim()) errors.userName = 'Enter your email';
        else if (!EMAIL_PATTERN.test(userName.trim())) errors.userName = 'Enter a valid email address';
        if (!password) errors.password = 'Enter your password';
        return errors;
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ submitted: true });
        if (Object.keys(this.errors()).length > 0) return;
        const { dispatch, history } = this.props;
        this.setState({ signingIn: true });
        dispatch(
            authenticateActions.authenticateUser(
                this.state.userName.trim(),
                this.state.password,
                () => history.push(landingRoute()),
                () => {
                    this.setState({ signingIn: false });
                    notify.createNotification('error', 'Email or password is incorrect', this.props.refNotify);
                }
            )
        );
    };

    toggleLoginMode = () => this.setState((prev) => ({ useMfa: !prev.useMfa }));

    render() {
        const { useMfa, userName, password, submitted, signingIn } = this.state;
        if (useMfa) {
            return (
                <AuthLayout title="Sign in with email code" subtitle="We'll email you a 6-digit code to sign in.">
                    <MfaLogin refNotify={this.props.refNotify} onSwitchLoginMode={this.toggleLoginMode} />
                </AuthLayout>
            );
        }
        const errors = submitted ? this.errors() : {};
        return (
            <AuthLayout title="Sign in" subtitle="Use the email and password set up for your agency.">
                <Box component="form" noValidate onSubmit={this.handleSubmit} sx={{ display: 'grid', gap: 2 }}>
                    <TextField
                        name="userName"
                        label="Email"
                        type="email"
                        autoComplete="username"
                        autoFocus
                        fullWidth
                        size="medium"
                        value={userName}
                        onChange={this.onChange}
                        error={Boolean(errors.userName)}
                        helperText={errors.userName}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <MailOutlineIcon fontSize="small" />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        name="password"
                        label="Password"
                        type="password"
                        autoComplete="current-password"
                        fullWidth
                        size="medium"
                        value={password}
                        onChange={this.onChange}
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockOutlinedIcon fontSize="small" />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: -0.5 }}>
                        <Link component={RouterLink} to="/forgetPwd" underline="hover" variant="body2">
                            Forgot password?
                        </Link>
                    </Box>
                    <Button type="submit" variant="contained" size="large" disabled={signingIn}>
                        {signingIn ? 'Signing in…' : 'Sign in'}
                    </Button>
                    <Divider sx={{ my: 0.5 }}>or</Divider>
                    <Button variant="outlined" size="large" onClick={this.toggleLoginMode}>
                        Sign in with an email code
                    </Button>
                </Box>
            </AuthLayout>
        );
    }
}

const mapStateToProps = (state) => ({
    authInfo: state.authInfo,
    refNotify: state.refNotify,
});

export default withRouter(connect(mapStateToProps)(Login));
